import API from 'services/api';

interface IProps {
  calculationId: string;
  payload: any;
}

export const updatePaymentModel = ({ calculationId, payload }: IProps): Promise<any> =>
  API.put(`api/accommodation/calculations/${calculationId}/paymentModelAndSource`, payload).then(
    response => response?.data,
  );
